import { IMAGES } from "./images";

// Blog mock data. Backend: replace via blogsService.getBlogPosts()
export const BLOG_CATEGORIES = ["Water Purification", "Laboratory Insights", "Weighing & Balances"];

const richContent = (lead) => [
  { type: "p", text: lead },
  { type: "h2", text: "Understanding the application first" },
  { type: "p", text: "At Athena Scientific, we believe the right solution begins with understanding the application. Before recommending any technology, we take time to understand a laboratory's objectives, workflow and constraints." },
  { type: "quote", text: "The right solution is not always the most complex one — it is the one that best meets your needs today while supporting tomorrow's goals." },
  { type: "h2", text: "What this means for your laboratory" },
  { type: "p", text: "This placeholder article demonstrates the blog layout and content model. Replace this content through your backend or CMS when it becomes available. Headings, paragraphs, quotes and images are all supported by the content renderer." },
  { type: "p", text: "For any questions on this topic, our team is always ready to help — reach out through the contact page or WhatsApp." },
];

export const BLOG_POSTS = [
  {
    id: "post-1",
    title: "Choosing the Right Laboratory Water: Type 1, 2 and 3 Explained",
    slug: "choosing-the-right-laboratory-water",
    excerpt:
      "Ultrapure, pure and RO water each serve different laboratory applications. Here is a clear, practical overview to help you match water quality to your workflow.",
    category: "Water Purification",
    author: "Athena Scientific",
    date: "2025-11-12",
    readTime: "5 min read",
    image: IMAGES.blog.water,
    featured: true,
    content: richContent(
      "Selecting the right grade of laboratory water is one of the most important — and most overlooked — decisions a laboratory makes."
    ),
  },
  {
    id: "post-2",
    title: "Why Preventive Maintenance Protects Your Laboratory Investment",
    slug: "why-preventive-maintenance-matters",
    excerpt:
      "Instruments perform best when they are cared for. A short look at how preventive maintenance supports reliability and continuity in the laboratory.",
    category: "Laboratory Insights",
    author: "Athena Scientific",
    date: "2025-10-28",
    readTime: "4 min read",
    image: IMAGES.blog.lab,
    featured: false,
    content: richContent(
      "Laboratory instruments are precision tools. Preventive maintenance helps protect both their performance and your investment over time."
    ),
  },
  {
    id: "post-3",
    title: "Precision Weighing: Getting Accurate, Repeatable Results",
    slug: "precision-weighing-accurate-results",
    excerpt:
      "Accurate weighing depends on more than the balance itself. A practical guide to environment, technique and instrument care.",
    category: "Weighing & Balances",
    author: "Athena Scientific",
    date: "2025-10-05",
    readTime: "6 min read",
    image: IMAGES.category["balances"],
    featured: false,
    content: richContent(
      "From draft shields to bench stability, small details make a measurable difference in analytical weighing."
    ),
  },
];

export const getBlogPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
